module.exports = __webpack_public_path__ + "img/cww_06.f4b76950.jpg";